import * as API from '../_api';

// @ts-ignore
export const initAnonymous = async ({ commit, dispatch }) => {
  try {
    const session = await API.anonymous();
    commit('setSession', session);
    sessionStorage.removeItem('session');
    commit('setAnonymous', true);
    dispatch('doctors/read', null, { root: true });
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, { root: true });
    return false;
  }
};

// @ts-ignore
export const initUser = async ({ commit, dispatch }) => {
  try {
    dispatch('catchments/setWelcomeDialog', false, { root: true });
    dispatch('catchments/setInfoDialog', false, { root: true });
    commit('setAnonymous', false);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, { root: true });
    return false;
  }
};

// @ts-ignore
export const changePassword = async ({ commit, dispatch }, { username, oldPassword, newPassword }) => {
  try {
    await API.changePassword(username, oldPassword, newPassword);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, { root: true });
    return false;
  }
};

// @ts-ignore
export const login = async ({ commit, dispatch }, { username, password }) => {
  try {
    const session = await API.login(username, password);
    sessionStorage.setItem('session', JSON.stringify(session));
    commit('setSession', session);
    commit('setAnonymous', false);
    dispatch('doctors/read', null, { root: true });
    return true;
  } catch (ex) {
    console.log(ex);
    dispatch('common/snackbar/error', ex, { root: true });
    return false;
  }
};
